const MODE_CONFIG = {
  recurring: {
    label: 'Récurrent',
    className: 'bg-blue-50 text-blue-700',
  },
  budget: {
    label: 'Budget',
    className: 'bg-purple-50 text-purple-700',
  },
  one_shot: {
    label: 'Ponctuel',
    className: 'bg-amber-50 text-amber-700',
  },
  provision: {
    label: 'Provision',
    className: 'bg-emerald-50 text-emerald-700',
  },
  debt: {
    label: 'Dette',
    className: 'bg-sky-50 text-sky-700',
  },
  revenue: {
    label: 'CA',
    className: 'bg-green-50 text-green-700',
  },
  indexed: {
    label: 'Indexé',
    className: 'bg-rose-50 text-rose-700',
  },
  monthly_budget: {
    label: 'Budget mensuel',
    className: 'bg-violet-100 text-violet-700',
  },
};

/**
 * Badge coloré indiquant le mode d'un item prévisionnel.
 * mode : 'recurring' | 'budget' | 'one_shot' | 'provision'
 */
export default function ForecastModeBadge({ mode }) {
  const config = MODE_CONFIG[mode];
  if (!config) return null;

  return (
    <span
      className={`inline-block shrink-0 text-[10px] font-medium px-1.5 py-0.5 rounded ${config.className}`}
    >
      {config.label}
    </span>
  );
}
